// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__R6DoK","header":"PatientQuestionnaire_header__80FTn","info":"PatientQuestionnaire_info__56-bz"};